// side effect: set housingPowerConnection from LU_cablelength
import {AttributeType, ChoiceValueDecisionState} from '@viamedici-spc/configurator-ts';
import {selectSpcConfiguration, selectSpcSession} from '../selectors';
import {conditional} from '../util/conditional';
import {getValueOfFeature} from '../util/values';

export const cableMiddleware = store => next => action => {
    const result = next(action);
	if (action.type === 'spc/spcStoreConfiguration') {
		const state = store.getState();
		const spcSession = selectSpcSession(state);
		const spcConfiguration = selectSpcConfiguration(state);
		const conditionalVariantValues = state.productData.conditionalVariantValues;

		if (spcSession !== null) {
			let cableLength = conditional(spcConfiguration, conditionalVariantValues, 'LU_CableLength');

			if (cableLength !== null) {
				if (!cableLength.endsWith('m')) {
					cableLength = cableLength + 'm';
				}

				const currentValue = getValueOfFeature('HS_HousingPowerConnection', spcConfiguration);

				// only add 'm' when not already present in cableLength
				if (currentValue !== cableLength) {
					spcSession.makeDecision({
							type: AttributeType.Choice,
							attributeId: {localId: 'HS_HousingPowerConnection'},
							choiceValueId: cableLength,
							state: ChoiceValueDecisionState.Included
						}
					);
				}
			}
        }
    }
    return result;
};
